import React, { useEffect } from "react";
import { Shield, Wrench, Truck, HeartHandshake } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";

export default function Services() {
  const navigate = useNavigate();
       useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);

  
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: "Services - ANS Safety Nets",
    url: "https://www.anssafetynets.com/services",
    description:
      "Explore the wide range of safety net services offered by ANS Safety Nets in Bengaluru, including balcony safety nets, children safety nets, industrial safety nets, pets safety nets, and more.",
    breadcrumb: {
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: "https://www.anssafetynets.com",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Services",
          item: "https://www.anssafetynets.com/services",
        },
      ],
    },
    publisher: {
      "@type": "Organization",
      name: "ANS Safety Nets",
      logo: {
        "@type": "ImageObject",
        url: "https://www.anssafetynets.com/logo.png",
        width: 250,
        height: 100,
      },
      contactPoint: [
        {
          "@type": "ContactPoint",
          telephone: "+91-7416116587",
          contactType: "Customer Service",
          areaServed: "IN",
          availableLanguage: ["English", "Kannada"],
        },
      ],
      sameAs: [
        "https://www.facebook.com/profile.php?id=61572534324956",
        "https://www.instagram.com/anssafetynets_bengaluru/",
      ],
    },
    mainEntity: {
      "@type": "Organization",
      name: "ANS Safety Nets",
      address: {
        "@type": "PostalAddress",
        streetAddress:
          "74/9, 5th Cross Rd, Muthyala Nagar, Bahubali Nagar, Jalahalli, Bengaluru, Karnataka 560013",
        addressLocality: "Bengaluru",
        addressRegion: "KA",
        postalCode: "560013",
        addressCountry: "IN",
      },
      service: [
        {
          "@type": "Service",
          name: "Balcony Safety Nets",
          areaServed: "Bengaluru",
        },
        {
          "@type": "Service",
          name: "Children Safety Nets",
          areaServed: "Bengaluru",
        },
        {
          "@type": "Service",
          name: "Pets Safety Nets",
          areaServed: "Bengaluru",
        },
        {
          "@type": "Service",
          name: "Industrial Safety Nets",
          areaServed: "Bengaluru",
        },
        {
          "@type": "Service",
          name: "Monkey Safety Nets",
          areaServed: "Bengaluru",
        },
        {
          "@type": "Service",
          name: "Cricket Practice Nets",
          areaServed: "Bengaluru",
        },
        {
          "@type": "Service",
          name: "Bird Spikes",
          areaServed: "Bengaluru",
        },
      ],
    },
  };
  return (
    <>
      <Helmet>
        <title>Services - ANS Safety Nets</title>
        <meta
          name="description"
          content="Explore the wide range of safety net services offered by ANS Safety Nets in Bengaluru, including balcony safety nets, children safety nets, industrial safety nets, pets safety nets, and more."
        />
        <meta
          name="keywords"
          content="safety nets in bengaluru , ans safety nets ,Ans Safety Nets bengaluru, Safety Nets in Bengaluru, ANS Safety Nets, safety nets in bengaluru, Safety Solutions, Bengaluru Safety Nets , balcony safety nets in bengaluru , balcony safety nets,pegion safety nets in bengaluru, monkey safety nets in bengaluru,Ducteria Nets in bengaluru, Pets Safety Nets in bengaluru, Industrial Safety Nets in bengaluru, Children Safety Nets in bengaluru, Bird Spikes in , Cricket Practice Nets in bengaluru,Sports Nets,Pigeon Safety Nets,Building covering Net,pigeon Safety Nets, Sports Nets in bengaluru,Pigeon Safety Nets in bengaluru,Building covering Net in bengaluru,pigeon Safety Nets in bengaluru"
        />
        <meta name="author" content="ANS Safety Nets, Bengaluru" />
        <meta name="email" content="anssafetynets@gmail.com" />
        <meta name="phone" content="+91- 7416116587" />
        <link rel="canonical" href="https://www.anssafetynets.com/services" />
        <script type="application/ld+json">{JSON.stringify(schemaData)}</script>
      </Helmet>
      <div className="pt-16">
        {/* Hero Section */}
        <div className="bg-[#2c3639]  py-20">
          <div className="max-w-7xl mx-auto px-4 text-center">
            <h1 className="text-4xl font-bold text-white mb-4">Our Services</h1>
            <p className="text-xl text-white">
              Comprehensive safety solutions for every need
            </p>
          </div>
        </div>

        {/* Services Grid */}
        <div className="py-20">
          <div className="max-w-7xl mx-auto px-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {[
                {
                  icon: Shield,
                  title: "Safety Net Installation",
                  description:
                    "Professional installation of safety nets for construction sites, events, and more.",
                  features: [
                    "Expert installation team",
                    "Quality assurance",
                    "Safety compliance",
                  ],
                },
                {
                  icon: Wrench,
                  title: "Maintenance & Repairs",
                  description:
                    "Regular maintenance and prompt repairs to ensure optimal safety performance.",
                  features: [
                    "Scheduled maintenance",
                    "24/7 emergency repairs",
                    "Safety inspections",
                  ],
                },
                {
                  icon: Truck,
                  title: "Custom Solutions",
                  description:
                    "Tailored safety solutions designed to meet your specific requirements.",
                  features: [
                    "Custom designs",
                    "Site assessment",
                    "Technical consultation",
                  ],
                },
                {
                  icon: HeartHandshake,
                  title: "Consultation Services",
                  description:
                    "Expert advice on safety requirements and regulations compliance.",
                  features: [
                    "Safety audits",
                    "Compliance checking",
                    "Risk assessment",
                  ],
                },
              ].map((service, index) => (
                <div key={index} className="bg-white p-8 rounded-lg shadow-md">
                  <service.icon className="h-12 w-12 text-[#a27b5c] mb-4" />
                  <h3 className="text-2xl font-semibold mb-4">
                    {service.title}
                  </h3>
                  <p className="text-gray-600 mb-6">{service.description}</p>
                  <ul className="space-y-2">
                    {service.features.map((feature, i) => (
                      <li key={i} className="flex items-center text-gray-600">
                        <span className="h-2 w-2 bg-[#2c3639] rounded-full mr-2"></span>
                        {feature}
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* CTA Section */}
        <div className="bg-[#d8d9dd] py-20">
          <div className="max-w-7xl mx-auto px-4 text-center">
            <h2 className="text-3xl font-bold mb-4">Need a Custom Solution?</h2>
            <p className="text-xl text-gray-600 mb-8">
              Contact us to discuss your specific requirements and get a
              personalized quote.
            </p>
            <button
              onClick={() => {
                navigate("/contact");
                window.scrollTo({
                  top: 0,
                  behavior: "smooth",
                });
              }}
              className="homecontactnavigatebtn"
            >
              Contact Us
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
